import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    getCouponslistApi,
    getCouponRedemptionsApi,
    createCoupon as createCouponRequest,
    updateCoupon as updateCouponApi,
} from "../../Api/AdminApiCall";

export const getCouponslist = createAsyncThunk(
    "admin/getCouponslist",
    async ({ page = 1, pageSize = 20, search = '', scope = '', status = '' }, { rejectWithValue }) => {
        try {
            const res = await getCouponslistApi(page, pageSize, search, scope, status);
            return res.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed to load coupons list");
        }
    }
);

export const createCouponApi = createAsyncThunk(
    "admin/createCoupon",
    async (data, { rejectWithValue }) => {
        try {
            const res = await createCouponRequest(data);
            return res.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed to create coupon");
        }
    }
);

export const getCouponRedemptions = createAsyncThunk(
    "admin/getCouponRedemptions",
    async ({ page = 1, pageSize = 10, search = '', status = '' }, { rejectWithValue }) => {
        try {
            const res = await getCouponRedemptionsApi(page, pageSize, search, status);
            return res.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed to load coupon redemptions");
        }
    }
);

export const updateCoupon = createAsyncThunk(
    "admin/updateCoupon",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await updateCouponApi(id, data);
            return res.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed to update coupon");
        }
    }
);

const CouponsSlice = createSlice({
    name: "CouponsSlice",
    initialState: {
        couponsList: { items: [] },
        redemptionsList: { items: [] },
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCouponslist.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getCouponslist.fulfilled, (state, action) => {
                state.loading = false;
                state.couponsList = action.payload;
            })
            .addCase(getCouponslist.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getCouponRedemptions.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getCouponRedemptions.fulfilled, (state, action) => {
                state.loading = false;
                state.redemptionsList = action.payload;
            })
            .addCase(getCouponRedemptions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(createCouponApi.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createCouponApi.fulfilled, (state, action) => {
                state.loading = false;
                if (!Array.isArray(state.couponsList?.items)) {
                    state.couponsList = { ...(state.couponsList || {}), items: [] };
                }
                state.couponsList.items.unshift(action.payload);
            })
            .addCase(createCouponApi.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateCoupon.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateCoupon.fulfilled, (state, action) => {
                state.loading = false;
                if (Array.isArray(state.couponsList?.items)) {
                    state.couponsList.items = state.couponsList.items.map((coupon) =>
                        coupon.id === action.payload.id ? action.payload : coupon
                    );
                }
            })
            .addCase(updateCoupon.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

const CouponsSliceReducer = CouponsSlice.reducer;
export default CouponsSliceReducer;




